export default "/images/icone-warning.svg?27b47f49cb52d2a229aeebdbff699c05";